import React from 'react';
import classNames from 'classnames';

import Data, { _F } from 'data';

import './CardView.scss';
import { getIconPath } from 'common';
import { WithCardTooltip } from 'tooltip';
import { formatHtml } from 'utils/format';
import { formatStat } from 'tooltip/ItemTooltip';

function CardSetEffects({ levels, set, onSelect }) {
  let count = 0, level = 0;
  for (const id of set.cards) {
    if (levels[id] != null) {
      count += 1;
      level += levels[id];
    }
  }
  const onMouseEnter = React.useCallback(() => onSelect?.(set.cards), [onSelect, set]);
  const onMouseLeave = React.useCallback(() => onSelect?.(null), [onSelect]);
  if (!count) return null;
  return set.effects.map((fx, index) => {
    if (fx.cards > count || fx.level > level) return null;
    const engraving = Data.engraving[fx.engrave?.id]?.desc?.[fx.engrave?.points / 5];
    return (
      <div key={index} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <div className="lap-header">{_F(fx.level ? 'sys.card.activated_card_set_effect_both_notice' : 'sys.card.activated_card_set_effect_cardcount_notice', set.name, fx.cards, fx.level)}</div>
        <ul className="lap-set-effects">
          {!!fx.addons && fx.addons.map(({type, stat, value}, index) => {
            if (type === 2) {
              const info = Data.itemStats[Data.statsMap[stat]];
              if (info) return <li key={index}>{_F(info.tip)} {formatStat(info, value)}</li>;
            } else if (type === 4) {
              const cfx = Data.combatEffect[stat];
              if (cfx) return <li key={index}>{formatHtml(cfx)}</li>;
            }
            return null;
          })}
          {fx.damageAttr && <li>{_F('sys.card.book_effect_desc_damattr', _F(Data.damageAttr[fx.damageAttr]))}</li>}
          {!!engraving && <li>{formatHtml(engraving)}</li>}
        </ul>
      </div>
    );
  });
}

export function CardEffects({ cards, onSelect }) {
  const levels = React.useMemo(() => {
    const levels = {};
    for (const card of cards) {
      if (card) levels[card.id] = card.awake || 0;
    }
    return levels;
  }, [cards]);
  return (
    <div className="lap-CardEffects">
      {Data.cardSets.map((set, index) => <CardSetEffects set={set} levels={levels} key={index} onSelect={onSelect}/>)}
    </div>
  );
}

function CardSlot({ card, selected }) {
  const cardData = Data.cards[card?.id];
  if (!cardData) return (
    <div className="lap-card">
      <div className="lap-card-name">&nbsp;</div>
      <div className="lap-card-art lap-empty"/>
    </div>
  );
  return (
    <div className={classNames(`lap-card lap-card-${Data.itemGrades[cardData.grade - 1].color}`, {"lap-selected": selected?.includes(card.id)})}>
      <div className="lap-card-name">{_F('sys.tooltip.card_name', cardData.name)}</div>
      <WithCardTooltip id={card.id} awake={card.awake}>
        <div className="lap-card-art">
          <img src={getIconPath(cardData.image)} alt={cardData.name}/>
          <div className="lap-card-border"/>
          <div className="lap-card-level">
            {!!card.awake && <div className={`lap-card-awake lap-card-awake-${card.awake}`}/>}
          </div>
        </div>
      </WithCardTooltip>
    </div>
  );
}

export default function CardView({ embed }) {
  const [selected, setSelected] = React.useState(null);
  return (
    <div className="lap-CardView">
      <div className="lap-CardList">
        {[0, 1, 2, 3, 4, 5].map(index => <CardSlot key={index} card={embed.cards[index]} selected={selected}/>)}
      </div>
      <CardEffects cards={embed.cards} onSelect={setSelected}/>
    </div>
  );
}
